<template>
    <div class="footer-menu ml-auto ml-md-5 d-flex flex-column flex-wrap flex-md-row">
        <v-btn
            v-for="(item, index) in footerMenu"
            :key="index"
            :to="!item.externalLink ? {name: 'infoPage', params: {link: item.link}} : null"
            variant="text"
            size="small"
            :href="item.externalLink ? item.link : null"
            :target="item.externalLink ? '_blank' : null"
            class="v-btn--router"
        >
            {{ item.name }}
        </v-btn>
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class FooterMenu extends Vue {
        get footerMenu() {
            return cmsStore.layoutSettings.footerMenu
        }
    }

    export default FooterMenu
</script>
